export default "__VITE_ASSET__CCaLg6r9__"